import styled from 'styled-components';
import colors from '../../../../styles/colors';

const FilePreviewContainer = styled.div`
  width: 600px;
  max-width: 100%;
  .rfu-file-previewer {
    background-color: ${colors.shades.gamma4};
    border: none;
    border-radius: 50px;
  }
  .rfu-file-previewer__close-button {
    display: none;
  }
`;

export {
  FilePreviewContainer,
};
